import { useState } from 'react';
import {
  Box,
  Dialog,
  IconButton,
  styled,
  Divider,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { Close } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';
import CAPA from './assets/CAPA.png';
import CAPA_BACKGROUND from './assets/CAPA_BACKGROUND.png';
import { formatDate } from '@utils/formatter';

// 22.11.30 후 관련 파일들 삭제
const CAPA_UPDATE_EXP = 'CAPA_UPDATE_EXP';

const CapaUpdateDialog = () => {
  const modalExpireDate = localStorage.getItem(CAPA_UPDATE_EXP);
  const currentDate = formatDate(new Date().toISOString(), 'YYYY/MM/DD');
  const isClose = new Date().getTime() >= new Date('2022-11-30').getTime();
  const noShow = modalExpireDate === 'never';
  const isShowInitState = modalExpireDate !== currentDate;
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));

  const [isShow, setIsShow] = useState(noShow ? false : isShowInitState);

  const handleCloseNever = () => {
    setIsShow(false);
    localStorage.setItem(CAPA_UPDATE_EXP, 'never');
  };

  const handleCloseToday = () => {
    localStorage.setItem(CAPA_UPDATE_EXP, currentDate);
    setIsShow(false);
  };

  if (!isShow || isClose) return null;
  return (
    <DialogWrapper open={isShow} onClose={handleCloseToday}>
      <CloseButton onClick={handleCloseToday}>
        <Close size={24} color={colorSet.gray000} />
      </CloseButton>
      <TopSection>
        <Img width={77} height={20} src={CAPA} alt="카파 로고" />
        <CustomizedTypography
          variant="body1"
          fontWeight="500"
          color="inherit"
          gutterBottoms={8}
        >
          2022.11.23
        </CustomizedTypography>
        <CustomizedTypography
          variant={matches ? 'h4' : 'h3'}
          fontWeight="700"
          color="inherit"
        >
          제조업체 매칭플랫폼 CAPA가 <br />
          한글 브랜드의 이름을 기존의 <br />
          ‘카파’에서 ‘캐파’로 변경합니다.
        </CustomizedTypography>
      </TopSection>
      <BottomSection>
        <CustomizedTypography variant="body2">
          <span style={{ fontWeight: 500 }}>
            이제 캐파로 불러주세요! 제조업체 매칭플랫폼 CAPA가 한글 브랜드의
            이름을 기존의 ‘카파’에서 ‘캐파’로 변경합니다.
          </span>{' '}
          지난 2020년 9월 CAPA가 처음 서비스를 시작한 이래 영문 ‘CAPA’와 함께
          한글 ‘카파’를 서비스명으로 사용해 왔습니다. 하지만 최근 서비스
          고도화를 위한 개편 작업을 진행하면서 브랜드명 또한 서비스의 본질을 더
          잘 나타낼 수 있도록 ‘캐파(공장의 생산 능력 등을 의미)’로 변경하기로
          했습니다. 이번 브랜드명 변경과 함께 조만간 더 나은 서비스로
          보답하겠습니다. 앞으로도 CAPA(캐파)에 많은 관심 부탁드리겠습니다.
        </CustomizedTypography>
      </BottomSection>
      <Divider />
      <ButtonSection>
        <CustomizedButton fullWidth color="default" onClick={handleCloseNever}>
          다시 보지 않기
        </CustomizedButton>
        <CustomizedButton fullWidth onClick={handleCloseToday}>
          닫기
        </CustomizedButton>
      </ButtonSection>
    </DialogWrapper>
  );
};

export default CapaUpdateDialog;

const CloseButton = styled(IconButton)({
  position: 'absolute',
  padding: 6,
  top: 18,
  right: 18
});

const Img = styled(`img`)({
  marginBottom: 28
});

const DialogWrapper = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 16,
    maxWidth: 476,
    width: '100%',
    [theme.breakpoints.down('md')]: {
      maxWidth: 375
    }
  }
}));

const TopSection = styled(Box)(({ theme }) => ({
  backgroundImage: `url(${CAPA_BACKGROUND})`,
  backgroundSize: `cover`,
  width: '100%',
  height: 275,
  padding: `34px 32px 41px`,
  color: colorSet.gray000,
  [theme.breakpoints.down('md')]: {
    padding: `34px 24px 41px`
  }
}));

const BottomSection = styled(Box)({
  padding: 20,
  backgroundColor: colorSet.gray100,
  borderRadius: 12,
  margin: `20px 16px`
});

const ButtonSection = styled(Box)({
  display: 'flex',
  gap: 7,
  margin: 16
});
